import {
    BonusDepositPanelMobileContainerStyled,
    BonusDepositPanelMobileContentStyled,
    BonusDepositPanelMobileHeaderStyled,
    BonusDepositPanelMobileInfoWrapperStyled,
    BonusDepositPanelMobileTermsCloseStyled,
    BonusDepositPanelMobileTermsContentStyled,
    BonusDepositPanelMobileTermsHeaderStyled,
    BonusDepositPanelMobileTermsTitleStyled,
    BonusDepositPanelMobileTotalAmountStyled,
} from "./styled/BonusDepositPanelMobileStyled";
import { Form, Offcanvas } from "react-bootstrap";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import BonusTimeMobile from "../BonusTimeMobile/BonusTimeMobile";
import { useBonusContext } from "../../bonusContext";
import amountFormat from "../../../../utils/amountFormat";
import { useCallback, useState } from "react";
import classNames from "classnames";
import { BinIcon } from "../../../../components/icon/Icon";

function BonusDepositPanelMobile(props) {
    const {bonusAmount, bonusPercent, depositAmount, initialOpenBonusTerms, isBonusApplied, handleChange} = props;
    const {bonusAvailableSecondsLeft} = useBonusContext();
    const {getLangPath} = useLangContext();
    const [showBonusTerms, setShowBonusTerms] = useState(initialOpenBonusTerms || false);

    const handleOpenTerms = useCallback(() => {
        setShowBonusTerms(true);
    }, []);

    const handleCloseTerms = useCallback(() => {
        setShowBonusTerms(false);
    }, []);

    return <>
        <BonusDepositPanelMobileHeaderStyled>
            <Form.Label>
                {getLangPath('deposit.bonuses')}
            </Form.Label>
            <BonusDepositPanelMobileInfoWrapperStyled onClick={handleOpenTerms}>
                <BinIcon name="IcInfoFilled"/>
            </BonusDepositPanelMobileInfoWrapperStyled>
        </BonusDepositPanelMobileHeaderStyled>
        <BonusDepositPanelMobileContainerStyled className={classNames({'bonus-applied': isBonusApplied})}>
            <BonusDepositPanelMobileContentStyled className={classNames({'bonus-applied': isBonusApplied})}>
                <Form.Check type="switch" id="apply-bonus" className="d-flex align-items-center">
                    <div className={'d-flex align-items-center'}>
                        <Form.Check.Input
                            checked={isBonusApplied}
                            onChange={handleChange}
                            role="button"
                        />
                        <Form.Label
                            dangerouslySetInnerHTML={{
                                __html: getLangPath('bonuses.get_bonus', {percent: bonusPercent})
                            }}
                        />
                    </div>
                </Form.Check>
                {(bonusAvailableSecondsLeft > 0) && <BonusTimeMobile/>}
            </BonusDepositPanelMobileContentStyled>
            <BonusDepositPanelMobileTotalAmountStyled>
                <div className={'label'}>{getLangPath('deposit.total_amount_with_bonus')}</div>
                <div className={'amount'}>${amountFormat(+bonusAmount + +depositAmount, 2)}</div>
            </BonusDepositPanelMobileTotalAmountStyled>
        </BonusDepositPanelMobileContainerStyled>
        <Offcanvas show={showBonusTerms} placement="end" style={{width: "100%"}}>
            <BonusDepositPanelMobileTermsHeaderStyled>
                <BonusDepositPanelMobileTermsCloseStyled onClick={handleCloseTerms}>
                    <BinIcon name={'IcClose'}/>
                </BonusDepositPanelMobileTermsCloseStyled>
                <BonusDepositPanelMobileTermsTitleStyled>
                    {getLangPath('bonuses.terms_title')}
                </BonusDepositPanelMobileTermsTitleStyled>
            </BonusDepositPanelMobileTermsHeaderStyled>
            <BonusDepositPanelMobileTermsContentStyled>
                <ol dangerouslySetInnerHTML={{__html: getLangPath('bonuses.terms')}}/>
            </BonusDepositPanelMobileTermsContentStyled>
        </Offcanvas>
    </>
}

export default BonusDepositPanelMobile;
